import React from 'react';
import { useField } from 'formik';
import { CharlyDatepicker } from 'components/shared/charly-datepicker/CharlyDatepicker';

type DateProps = {
    label: string;
    name: string;
    isMandatory?: boolean;
    maxDate?: string;
    minDate?: string;
    value?: string;
    className?: string;
};

export const DateInput: React.FC<DateProps> = ({
    label,
    name,
    isMandatory = true,
    maxDate,
    minDate,
    value,
    className,
}) => {
    const [field, meta, helper] = useField(name);
    const currentValue = value ?? field.value ?? '';

    return (
        <CharlyDatepicker
            name={name}
            label={label}
            value={currentValue}
            onChange={(iso) => helper.setValue(iso)}
            min={minDate}
            max={maxDate}
            required={isMandatory}
            errorMessage={meta.touched && meta.error ? meta.error : undefined}
            className={className}
        />
    );
};
